/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconDianyingXuanzhong: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1609 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M1419.41248 69.193143c0-44.105143 22.308571-79.067429 66.56-66.633143 29.476571 8.192 48.566857 37.595429 48.566857 69.12v319.780571h46.299429c15.579429 0 28.525714 13.165714 28.306285 29.622858v154.770285a29.257143 29.257143 0 0 1-28.525714 29.622857h-30.208v160.841143c0 141.750857-111.689143 257.682286-248.100571 257.682286h-210.797715c-136.411429 0-248.100571-115.931429-248.100571-257.682286V551.350857a14.482286 14.482286 0 0 0-14.116571-14.628571h-49.517715a14.482286 14.482286 0 0 0-14.116571 14.628571v214.966857c0 141.750857-111.616 257.682286-248.100572 257.682286H306.763337C170.425051 1024 58.735909 908.068571 58.735909 766.317714v-160.914285H28.527909A29.257143 29.257143 0 0 1 0.002194 575.926857V421.083429a29.257143 29.257143 0 0 1 28.525715-29.622858h46.153142V69.193143c0-44.105143 16.164571-69.193143 63.853715-66.633143 47.689143 2.486857 48.566857 37.595429 48.566857 69.12v319.780571h1232.310857zM571.613623 472.649143H247.225051c-64.950857 0-118.052571 56.905143-118.052571 126.537143v165.010285c0 99.693714 76.068571 181.028571 168.813714 181.028572h223.158857c92.745143 0 168.594286-81.334857 168.448-180.809143V599.186286c0-69.632-53.101714-126.537143-118.052571-126.537143z m796.379428 0h-330.459428c-64.950857 0-118.052571 56.905143-118.052572 126.537143v165.229714c0 99.474286 75.849143 180.809143 168.594286 180.809143h229.156572c92.745143 0 168.813714-81.334857 168.813714-181.028572V599.186286c0-69.632-53.101714-126.537143-118.052572-126.537143z"
        fill={getIconColor(color, 0, '#FFFFFF')}
      />
    </svg>
  );
};

IconDianyingXuanzhong.defaultProps = {
  size: 18,
};

export default IconDianyingXuanzhong;
